module.exports = __webpack_public_path__ + "img/JMWLP_studio-page-banner@3x.f200b179.jpg";